var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * SupportHeadphones component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconSupportHeadphones extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.0884 2.05762L12.07 2.05784C9.41529 2.12285 7.62024 3.19886 6.50541 4.63309C5.41284 6.03868 5.01245 7.73554 5.01245 9.03142V9.88525H3.25547C2.06806 9.88525 1.10547 10.8478 1.10547 12.0353V15.4784C1.10547 16.6658 2.06806 17.6284 3.25547 17.6284H4.95732C5.81337 17.6284 6.50732 16.9345 6.50732 16.0784V11.0476C6.51071 11.0187 6.51245 10.9893 6.51245 10.9594V9.03142C6.51245 8.00487 6.83789 6.64952 7.68971 5.55365C8.51812 4.4879 9.88338 3.61417 12.0975 3.55762C14.0374 3.56028 15.3702 4.40842 16.2341 5.49066C17.1207 6.60139 17.5031 7.94958 17.4969 8.8613V9.88525H17.4937V16.0784C17.4937 16.1124 17.4947 16.1461 17.4969 16.1795V18.1687C17.4969 19.4113 16.4895 20.4187 15.2469 20.4187H12.7642C12.35 20.4187 12.0142 20.7545 12.0142 21.1687C12.0142 21.5829 12.35 21.9187 12.7642 21.9187H15.2469C17.318 21.9187 18.9969 20.2397 18.9969 18.1687V17.6277C19.0124 17.6282 19.028 17.6284 19.0437 17.6284H20.7455C21.9329 17.6284 22.8955 16.6658 22.8955 15.4784V12.0353C22.8955 10.8478 21.9329 9.88525 20.7455 9.88525H18.9969V8.86878C19.0047 7.60954 18.5039 5.92975 17.4064 4.55488C16.2868 3.15226 14.5358 2.05762 12.0884 2.05762ZM18.9969 16.0962V11.3853H20.7455C21.1045 11.3853 21.3955 11.6763 21.3955 12.0353V15.4784C21.3955 15.8374 21.1045 16.1284 20.7455 16.1284H19.0437C19.0223 16.1284 19.0041 16.115 18.9969 16.0962ZM3.25547 11.3853C2.89648 11.3853 2.60547 11.6763 2.60547 12.0353V15.4784C2.60547 15.8374 2.89648 16.1284 3.25547 16.1284H4.95732C4.98494 16.1284 5.00732 16.106 5.00732 16.0784V11.3853H3.25547Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconSupportHeadphones.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconSupportHeadphones.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconSupportHeadphones.prototype, "size", void 0);
if (customElements.get('cat-icon-support-headphones') === undefined) {
    customElements.define('cat-icon-support-headphones', BlocksIconSupportHeadphones);
}
